import React, { Fragment } from "react";
import { Button, CardActions, CardContent, Divider, Grid, IconButton, TextField, Tooltip, Typography, makeStyles } from "@material-ui/core";
import Edit from "@material-ui/icons/Edit";
import { FormattedMessage, injectIntl } from "react-intl";

import { getTemplates } from "../actions/EmailTemplate";
import FormDialog from "../custom/FormDialog";
import HeaderPageItem from "../custom/HeaderPageItem";
import PageContainer, { CardPageItem } from "../custom/Page";
import FormEmailTemplate from "./components/FormEmailTemplate";

const useStyles = makeStyles((theme) => ({
  search: {
    marginBottom: theme.spacing(4),
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
  center: {
    textAlign: "center",
  },
}));

const ConfigEmailTemplate = ({ intl }) => {
  const classes = useStyles();

  const [templates, setTemplates] = React.useState([]);
  const [modal, setModal] = React.useState(false);
  const [title, setTitle] = React.useState("");
  const [selectedTemplate, setSelectedTemplate] = React.useState(null);
  const [search, setSearch] = React.useState("");

  const loadTemplates = React.useCallback(async () => {
    const data = await getTemplates();

    const formattedTemplates = data
      .map((template) => ({
        ...template,
        translatedType: intl.formatMessage({
          id: `app.enuns.emailTemplate.${template.type}`,
        }),
        translatedLocale: intl.formatMessage({
          id: `app.enuns.${template.locale}`,
        }),
      }))
      .sort((t1, t2) => (t1.type > t2.type ? 1 : -1));
    setTemplates(formattedTemplates);
  }, [intl]);

  const openCreateModal = () => {
    setSelectedTemplate(null);
    setTitle("app.createNewTemplate");
    setModal(true);
  };

  const openEditModal = (template) => {
    setSelectedTemplate(template);
    setTitle("app.editTemplate");
    setModal(true);
  };

  const closeModal = () => {
    setModal(false);
    setSelectedTemplate(null);
  };

  React.useEffect(() => {
    loadTemplates();
  }, [intl, loadTemplates]);

  const filteredTemplates = templates.filter((template) => {
    const value = search.toLowerCase();

    return (
      template.locale.toLowerCase().includes(value) ||
      template.type.toLowerCase().includes(value) ||
      template.subject.toLowerCase().includes(value) ||
      template.translatedLocale.toLowerCase().includes(value) ||
      template.translatedType.toLowerCase().includes(value)
    );
  });

  return (
    <PageContainer>
      <HeaderPageItem title="app.emailTemplates" showBackButton destination="/more" />

      <CardPageItem>
        <CardContent>
          <TextField fullWidth variant="outlined" size="small" label="Procurar template" value={search} onChange={(e) => setSearch(e.target.value)} className={classes.search} />

          <Grid container spacing={2}>
            <Grid item xs={5}>
              <Typography variant="body1">
                <FormattedMessage id="app.type" />
              </Typography>
            </Grid>

            <Grid item xs={4}>
              <Typography variant="body1">
                <FormattedMessage id="app.subject" />
              </Typography>
            </Grid>

            <Grid item xs={2}>
              <Typography variant="body1">
                <FormattedMessage id="app.language" />
              </Typography>
            </Grid>

            <Grid item xs={1} className={classes.center}>
              <Typography variant="body1">
                <FormattedMessage id="app.edit" />
              </Typography>
            </Grid>
          </Grid>

          <Divider className={classes.divider} />

          {filteredTemplates.map((t) => (
            <Fragment key={t.id}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={5}>
                  <Tooltip title={`${t.type} - ID: ${t?.id}`} arrow>
                    <Typography variant="caption">{t?.translatedType}</Typography>
                  </Tooltip>
                </Grid>

                <Grid item xs={4}>
                  <Typography variant="caption">{t.subject}</Typography>
                </Grid>

                <Grid item xs={2}>
                  <Typography variant="caption">{t.translatedLocale}</Typography>
                </Grid>

                <Grid item xs={1} className={classes.center}>
                  <IconButton onClick={() => openEditModal(t)}>
                    <Edit />
                  </IconButton>
                </Grid>
              </Grid>

              <Divider className={classes.divider} />
            </Fragment>
          ))}
        </CardContent>
      </CardPageItem>

      <FormDialog title={title} open={modal} variant="secondary" noHeader onClose={closeModal}>
        <FormEmailTemplate
          template={selectedTemplate}
          templates={templates}
          onActionComplete={() => {
            closeModal();
            loadTemplates();
          }}
        />
      </FormDialog>
    </PageContainer>
  );
};

export default injectIntl(ConfigEmailTemplate);
